/**
 * Route for `pinterest-ads-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PinterestAdsIntegrationPage } from "../features/pinterest-ads-integration/PinterestAdsIntegrationPage";

export const pinterestAdsIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/pinterest-ads-integration",
	component: PinterestAdsIntegrationPage,
});

export default pinterestAdsIntegrationRoute;
